import { isEmpty } from "utils/array";
import removeParentByPermissions from 'utils/permissions'

export function includesClass(target,name){
    try{
        return !target.className.includes(name)
    }catch{
        return true
    }
}
export function findClass(target,name,count=2){
    let aux=0
    while(includesClass(target,name)){
        if(aux==count) return false;
        if(!target) return false;
        target = target.parentNode
        aux++;
    }
    if(aux==count) return false
    return target
}

export function checkChilds(module,auth,SUPER,ADMIN){
    
    const hasChildren = module.children && !isEmpty(module.children)
    if(hasChildren){
        let childs = module.children.map(child=>{
            return removeParentByPermissions(auth,null,SUPER,ADMIN,child)?
            child:null
        }).filter(item=>item)
        return {...module,children:childs}
    }
    else{
        return {...module}
    }
}

export function checkSection(modules,section,moduleCheck,active){
    if(!section) return 
    if(modules[section.index]){
        modules[section.index].modules = [...(modules[section.index].modules || []),{...moduleCheck,menu:active}]
    }else{
        modules[section.index] = {
            nome:section.nome,
            modules:[{...moduleCheck,menu:active}]
        }
    }
}